<div class="section-divider d-none d-md-flex align-items-center gap-3 my-3">
  <div class="flex-grow-1 border-top"></div>
  <span class="fw-semibold small text-uppercase text-muted px-1" style="letter-spacing:.08em;">🌡 {{ 'TAB_KLIMA' | translate }}</span>
  <div class="flex-grow-1 border-top"></div>
</div>

<!-- KNX room temperatures (the Govee thermometers are no longer shown) -->
<app-knx-rooms
  [thermometers]="thermometers"
  [thermometerHistory]="thermometerHistory"
  [knxFlash]="knxFlash"
  [knxUpdatedAt]="knxUpdatedAt"
  [liveDotOn]="liveDotOn"
  [nowTick]="nowTick"
  [darkMode]="darkMode"
  [adminAuth]="adminAuth"
  (adminUnauthorized)="adminUnauthorized.emit()">
</app-knx-rooms>
